import React, { useState, useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Select as AntSelect, Divider, Button as AntButton } from 'antd';
import css from '../../styles/modules/WiringInstructions/sendmoney.module.css';
import { saveTransferDoc } from '../../reducers/transfer/TransferActions';
import '../CreateAccountWizard/createAccount.css';
import '../SendMoney/SendMoney.css';
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Typography,
  Modal,
  Backdrop,
} from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import copy from '../../styles/assets/content_copy.png';
import handCross from '../../styles/assets/hand-cross.png';
import handFinger from '../../styles/assets/One.png';
import expireCalender from '../../styles/assets/expired.png';
import indeaMessage from '../../styles/assets/private chat.png';
import { Container, Row, Col } from 'react-bootstrap';
import BoxContainerWiring from '../BoxContainer/BoxContainerWiring';
import close from '../../styles/assets/close.png';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import Payment from '../../styles/assets/Payment.png';
import onlineBanking from '../../styles/assets/online banking.png';
import phoneDollar from '../../styles/assets/phone-dollar.png';
import { useTransfer } from '../../utils/service/service_transfer_api';
import { useAllTenants } from '../../utils/service/service_tenant_api';
import { setLoading } from '../../reducers/utility/utilityActions';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';
import useWindowWidth from '../../hooks/nonGQLhooks/useWindowWidth';
const Title = () => (
  <div className="create-account__line-container">
    <div className="create-account__title"></div>
  </div>
);

function InfoTransfer() {
  const windowWidth = useWindowWidth();
  return (
    <>
      {windowWidth < 1024 ? (
        <div className={css.componentWrapper}>
          <SecondaryText
            text={
              'You are ready to send your funds! These are the steps you can take in order to wire your funds.'
            }
          />
        </div>
      ) : (
        <>
          <SecondaryText
            text={
              'You are ready to send your funds! These are the steps you can take in order to wire your funds.'
            }
          />
        </>
      )}
    </>
  );
}

const MainText = ({ text }) => (
  <div className={css.sendMoneyHeadline}>{text}</div>
);

const DoYourPartContent = ({ image, textH2, textP1 }) => (
  <div className="image-components text-center ">
    <h2 style={{ flex: 1 }}>{textH2}</h2>
    <figure>
      <img src={image} />
    </figure>
    <p>{textP1}</p>
  </div>
);

const useStyles = makeStyles((theme) => ({
  card: {},
  logo: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: theme.palette.secondary.main,
  },
}));

const MaterialUICard = () => {
  const windowWidth = useWindowWidth();
  let contents = [
    {
      image: Payment,
      textH5: 'Visit your local Banking Center',
      textP1: 'A banking representative can assist with wiring funds.',
    },
    {
      image: onlineBanking,
      textH5: 'Access your online banking app',
      textP1:
        'Some banks allow you to initiate a wire through your online banking app.',
    },
    {
      image: phoneDollar,
      textH5: 'Call your Bank',
      textP1:
        'Contact your bank and take the steps needed over the phone to send a wire.',
    },
  ];
  return (
    <div className={windowWidth < 1024 ? css.componentWrapper : null}>
      <div className="d-flex justify-content-center mt-5 mb-5 pictureContainer">
        {contents.map((content, index) => (
          <DoYourPartContent
            image={content.image}
            textH2={content.textH5}
            textP1={content.textP1}
          />
        ))}
      </div>
    </div>
  );
};

const SecondaryText = ({ text }) => (
  <div className={css.secondaryText}>{text}</div>
);

const SendMoney = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const transfer_id = queryParams.get('transfer_id');
  const tenant_id = queryParams.get('tenant_id');
  useTransfer(transfer_id).refetchTransfer();
  const transfer_detail = useTransfer(transfer_id).transfer;
  const history = useHistory();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state).utility;

  //scrolls all pages to the top on page change.
  useEffect(() => {
    setTimeout(() => {
      document.querySelector('body').scrollTo(0, 0);
      document.querySelector('html').scrollTo(0, 0);
    }, 1);
  }, [location]);

  return (
    <>
      {isLoading === true ? <SpinnerLoader /> : null}
      <Title />
      <InfoTransfer />
      <MaterialUICard transfer_detail={transfer_detail} />
    </>
  );
};

export default withRouter(
  connect((state) => ({}), {
    onSaveTransferDoc: saveTransferDoc,
  })(SendMoney),
);
